import { Editor } from "grapesjs";
import { RequiredPluginOptions } from "../../../../../types/types";
import { html } from "../../../../../utils/tw";

export default async (editor: Editor, opts: RequiredPluginOptions) => {
  const { Components } = editor;

  Components.addType("add-to-cart", {
    isComponent: (el) => {
      if (
        el.className &&
        typeof el.className === "string" &&
        el.className.includes("addToCart")
      ) {
        return {
          type: "add-to-cart",
        };
      }
      return false;
    },
    model: {
      defaults: {
        tagName: "main",
        classes: ["addToCart", "flex-1"],
        components: html`
          <section class="container mx-auto px-4 my-4" id="section-container">
            <div class="flex items-center justify-between  md:mb-6 mb-3 ">
              <div class="flex items-center gap-x-2">
                <div
                  class="border-s-4 border-[var(--primary)] md:h-7 h-5 relative"
                ></div>
                <h2
                  class="text-xl font-medium md:font-semibold font-montserrat md:text-3xl"
                >
                  Shopping Cart
                </h2>
              </div>
            </div>
            <!-- {% cart_items as products_list %}
                       {% if not products_list.cart_item_list %}
                       <div class="flex-1 flex items-center justify-center">
                        <p> No item in cart at the moment.</p>
                        <div>
                        {% else %} -->
            <div
              class="grid md:grid-cols-4 md:gap-x-10"
              id="shopping-cart-container"
            >
              <div class="col-span-3">
                <div class="hidden md:grid grid-cols-4 text-2xl font-semibold ">
                  <p class="col-span-2 ">Product</p>
                  <p>Quantity</p>
                  <p>Total</p>
                </div>

                <!--
                      {% for item_dict in products_list.cart_item_list %} -->
                <div
                  class="cart-item grid grid-cols-1 md:grid-cols-4 gap-y-2 gap-x-2 border-b border-black my-2 md:my-10 pb-4 items-center "
                  data-product-slug="{{ item_dict.product.slug }}"
                >
                  <div class="flex gap-x-2 col-span-2 ">
                    <div class="w-32 h-32 flex-shrink-0">
                      <!-- {% comment %} -->
                      <img
                        src="{item.image}"
                        alt="{item.name}"
                        class="object-cover w-full h-full rounded-md border border-gray-200"
                      />
                      <!-- {% endcomment %} -->
                      <!-- <img
                        src="{% generate_thumbnail item_dict.product.image_url '200x200/filters:format(webp)' %}"
                        alt="{{ item_dict.product.name }}"
                        class="object-cover w-full h-full rounded-md border border-gray-200"/> -->
                    </div>
                    <div class="flex flex-col">
                      <div class="flex gap-x-4 items-center">
                        <h3
                          class="md:text-xl text-black font-semibold md:mb-4 line-clamp-2 md:line-clamp-none"
                        >
                          <!-- {% comment %} -->
                          Shirt
                          <!-- {% endcomment %} -->
                          <!-- {{ item_dict.product.name|title }} -->
                        </h3>
                        <button
                          type="button"
                          class="text-[var(--primary)] md:hidden remove-item-mobile "
                          data-slug="{{ item_dict.product.slug }}"
                        >
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M3 6H5M5 6H21M5 6V20C5 20.5304 5.21071 21.0391 5.58579 21.4142C5.96086 21.7893 6.46957 22 7 22H17C17.5304 22 18.0391 21.7893 18.4142 21.4142C18.7893 21.0391 19 20.5304 19 20V6M8 6V4C8 3.46957 8.21071 2.96086 8.58579 2.58579C8.96086 2.21071 9.46957 2 10 2H14C14.5304 2 15.0391 2.21071 15.4142 2.58579C15.7893 2.96086 16 3.46957 16 4V6M10 11V17M14 11V17"
                              stroke="currentColor"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            ></path>
                          </svg>
                        </button>
                      </div>
                      <div class="grid grid-cols-2 gap-2 ">
                        <p>Price:</p>
                        <p
                          class="text-[16px] font-semibold text-[var(--primary)] item-price"
                        >
                          Rs.
                          <!-- {% comment %} -->
                          999
                          <!-- {% endcomment %} -->
                          <!-- {% if item_dict.product.selling_price %} {{ item_dict.product.selling_price}} {% else %} 0 {% endif %} -->
                        </p>
                        <p class="md:hidden">Quantity</p>
                        <div class="md:hidden flex items-center gap-x-2">
                          <button
                            class="border border-[var(--primary)] w-7 minus-btn hover:bg-gray-300 overflow-hidden relative ripple-effect"
                          >
                            -
                          </button>
                          <!-- {% comment %} -->
                          <input
                            type="text"
                            value="1"
                            class="border border-[var(--primary)] w-10 text-center item-quantity-mobile "
                            min="1"
                            max="5"
                          />
                          <!-- {% endcomment %} -->
                          <!-- <input
                              type="text"
                              value="{{ item_dict.quantity }}"
                              class="border border-[var(--primary)] w-10 text-center item-quantity-mobile"
                              min="1"
                              max="{{ item_dict.product.available_quantity }}"
                            /> -->

                          <button
                            class="border border-[var(--primary)] w-7 plus-btn hover:bg-gray-300 overflow-hidden relative ripple-effect"
                          >
                            +
                          </button>
                        </div>

                        <p class="md:hidden">Total</p>
                        <p
                          class="md:hidden text-[16px] font-semibold text-[var(--primary)] total-price-mobile total-price-mobile"
                        >
                          Rs.999
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="hidden md:flex items-center gap-x-4">
                    <button
                      class="border border-[var(--primary)] w-6 minus-btn-desktop cursor-pointer hover:bg-gray-300 overflow-hidden relative ripple-effect"
                    >
                      -
                    </button>
                    <!-- {% comment %} -->
                    <input
                      type="text"
                      value="1"
                      class="border border-[var(--primary)] w-10 text-center item-quantity-desktop "
                      min="1"
                      max="5"
                    />
                    <!-- {% endcomment %} -->
                    <!-- <input
                        type="text"
                        value="{{ item_dict.quantity }}"
                        class="border border-[var(--primary)] w-10 text-center item-quantity-desktop"
                        min="1"
                        max="{{ item_dict.product.available_quantity }}"
                      /> -->

                    <button
                      class="border border-[var(--primary)] w-6 plus-btn-desktop cursor-pointer hover:bg-gray-300 overflow-hidden relative ripple-effect"
                    >
                      +
                    </button>
                  </div>

                  <div class="md:flex hidden justify-between  items-center">
                    <p class="font-semibold  total-price-desktop">Rs.999</p>
                    <button
                      class="border p-3 rounded-full cursor-pointer remove-item hover:bg-gray-300 overflow-hidden relative ripple-effect"
                      id="{{ item_dict.product.slug }}"
                    >
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M12 4L4 12M4 4L12 12"
                          stroke="currentColor"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        ></path>
                      </svg>
                    </button>
                  </div>
                </div>
                <!-- {% endfor %} -->
                <div
                  class="md:hidden w-full flex flex-col items-end justify-center "
                >
                  <div class="flex justify-between items-center w-full">
                    <p class="uppercase text-lg ">Total</p>
                    <p class="grand-total-mobile">Rs.99999</p>
                  </div>
                  <a href="/checkout" class="w-32 cursor-pointer">
                    <div class="w-full">
                      <button
                        type="button"
                        class="bg-[var(--primary)] text-white w-full text-center py-2 rounded-lg focus:outline-none uppercase cursor-pointer relative overflow-hidden ripple-effect"
                      >
                        Check Out
                      </button>
                    </div>
                  </a>
                </div>
              </div>
              <div class="hidden md:block bg-[#F5F5F5] p-4 rounded-lg ">
                <div class="flex items-center justify-start gap-x-2">
                  <div
                    class="border-s-4 border-[var(--primary)] h-8 relative -top-2"
                  ></div>
                  <h2 class="font-medium font-montserrat text-3xl mb-5">
                    Summary
                  </h2>
                </div>
                <!-- {% for item_dict in products_list.cart_item_list %} -->

                <div
                  class="product-summary flex justify-between items-center text-sm border-b border-gray-300"
                  data-slug="{{ item_dict.product.slug }}"
                >
                  <span class="name">
                    <!-- {% comment %} -->
                    shirt
                    <!-- {% endcomment %} -->
                    <!-- {{ item_dict.product.name|title }} -->
                  </span>
                  <span class="quantity">
                    <!-- {% comment %} -->
                    x1
                    <!-- {% endcomment %} -->
                    <!-- {{ item_dict.quantity }} -->
                  </span>
                </div>
                <!-- {% endfor %} -->
                <hr />
                <div
                  class="flex flex-col justify-center items-center gap-y-3 mt-4"
                >
                  <div class="flex justify-between items-center w-full">
                    <p class="text-lg font-semibold ">Total</p>
                    <p class="grand-total-desktop">Rs.9999</p>
                  </div>

                  <div
                    class="w-full flex flex-col justify-center items-center h-60 px-4"
                  >
                    <a
                      href="/checkout"
                      class="text-white rounded p-2 shadow bg-[var(--primary)] text-center uppercase block w-full mx-4 m-auto cursor-pointer relative overflow-hidden ripple-effect"
                    >
                      Check Out
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <!-- {% endif %} -->
          </section>
        `,
        script: function () {
          let total = 0;
          const cartItems = [];
          const grandTotalMobile = document.querySelector(
            ".grand-total-mobile"
          ) as HTMLElement;
          const grandTotalDesktop = document.querySelector(
            ".grand-total-desktop"
          ) as HTMLElement;
          const checkoutBtn = document.querySelector(
            "#checkout-btn"
          ) as HTMLButtonElement;
          // checkoutBtn.addEventListener("click", () => {
          //   handleCheckout();
          // });
          function updateGrandTotal() {
            total = 0;
            const itemContainers = document.querySelectorAll(".cart-item");

            itemContainers.forEach((container) => {
              const totalPriceDesktop = container.querySelector(
                ".total-price-desktop"
              ) as HTMLElement;
              const totalPriceMobile = container.querySelector(
                ".total-price-mobile"
              ) as HTMLElement;

              if (totalPriceDesktop) {
                const price = parseInt(
                  totalPriceDesktop.innerText.replace("Rs.", "").trim()
                );
                if (!isNaN(price)) {
                  total += price;
                }
              } else if (totalPriceMobile) {
                const price = parseInt(
                  totalPriceMobile.innerText.replace("Rs.", "").trim()
                );
                if (!isNaN(price)) {
                  total += price;
                }
              }
            });

            if (grandTotalDesktop || grandTotalMobile) {
              grandTotalDesktop.innerText = `Rs.${total}`;
              grandTotalMobile.innerText = `Rs.${total}`;
            }
          }

          function updateQuantities(cart) {
            cart.forEach((item) => {
              const productElement = document.querySelector(
                `.product-summary[data-slug="${item.slug}"]`
              );

              if (productElement) {
                const quantityElement =
                  productElement.querySelector(".quantity");
                if (quantityElement) {
                  quantityElement.textContent = `x${item.quantity}`;
                }
              }
            });
          }

          function updateTotalPrice(container: HTMLElement) {
            const productSlug = container.getAttribute("data-product-slug");
            const quantityInputMobile = container.querySelector(
              ".item-quantity-mobile"
            ) as HTMLInputElement;
            const quantityInputDesktop = container.querySelector(
              ".item-quantity-desktop"
            ) as HTMLInputElement;
            const itemPrice = container.querySelector(
              ".item-price"
            ) as HTMLElement;
            const totalPriceDesktop = container.querySelector(
              ".total-price-desktop"
            ) as HTMLElement;
            const totalPriceMobile = container.querySelector(
              ".total-price-mobile"
            ) as HTMLElement;

            if (!itemPrice || !totalPriceDesktop || !totalPriceMobile) return;

            let price = parseInt(itemPrice.innerText.replace("Rs.", "").trim());
            let quantity = 1;
            let maxValue;
            if (quantityInputDesktop) {
              maxValue =
                parseInt(quantityInputDesktop.getAttribute("max"), 10) || 10;
            } else {
              maxValue =
                parseInt(quantityInputMobile.getAttribute("max"), 10) || 10;
            }

            // plusBtn.addEventListener("click", () => {
            //   const currentValue = parseInt(quantityInput.value, 10) || 1;
            //   quantityInput.value = String(
            //     Math.min(maxValue, currentValue + 1)
            //   );
            // });

            // minusBtn.addEventListener("click", () => {
            //   const currentValue = parseInt(quantityInput.value, 10) || 1;
            //   if (currentValue > 1) {
            //     quantityInput.value = String(currentValue - 1);
            //   }
            // });

            if (Number(quantityInputDesktop.value) < 1) {
              quantityInputDesktop.value = "1";
            } else if (Number(quantityInputDesktop.value) > maxValue) {
              quantityInputDesktop.value = String(maxValue);
            }

            if (Number(quantityInputMobile.value) < 1) {
              quantityInputMobile.value = "1";
            } else if (Number(quantityInputMobile.value) > maxValue) {
              quantityInputMobile.value = String(maxValue);
            }

            if (quantityInputDesktop && quantityInputDesktop.value) {
              quantity = parseInt(quantityInputDesktop.value);
            } else if (quantityInputMobile && quantityInputMobile.value) {
              quantity = parseInt(quantityInputMobile.value);
            }

            if (isNaN(quantity) || quantity < 1) quantity = 1;

            totalPriceDesktop.innerText = `Rs.${quantity * price}`;
            totalPriceMobile.innerText = `Rs.${quantity * price}`;

            if (productSlug) {
              cartItems.push({
                slug: productSlug,
                quantity: quantity.toString(),
              });
            }

            handleQuantityUpdate(productSlug, quantity.toString());
            updateGrandTotal();
            updateQuantities(cartItems);
          }

          let toastify;
          const initToastLib = function () {
            //@ts-ignore
            toastify = Toastify({
              text: "Item removed from cart.",
              duration: 2000,
              // destination: "/",
              // newWindow: false,
              close: false,
              gravity: "top",
              position: "right",
              stopOnFocus: true,
              offset: {
                x: 20,
                y: 60,
              },
            });
          };

          function handleRemoveItem(removeBtn) {
            let slug;
            if (removeBtn?.id) {
              slug = removeBtn?.id;
            } else {
              slug = removeBtn?.dataset?.slug;
            }

            fetch("{% url 'remove_from_cart' %}", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({
                slug: slug,
              }),
            })
              .then((response) => {
                if (response?.status !== 200) {
                  throw new Error("Failed to remove product from cart");
                }
                return response.json();
              })
              .then((result) => {
                const sanitizedSlug = slug.replace(/[^\w-]/g, "_");
                const cartItem = document.querySelector(
                  `[data-product-slug="${sanitizedSlug}"]`
                );
                cartItem?.remove();
                const cartElement = document.getElementById("cart-count");
                cartElement.textContent = result.cart_count;
                toastify.showToast();
                if (result.cart_count === 0) {
                  const shoppingCartContainer = document.querySelector(
                    "#shopping-cart-container"
                  );
                  shoppingCartContainer?.classList.add("hidden");
                  const sectionContainer =
                    document.querySelector("#section-container");
                  const paragraphElement = document.createElement("p");
                  const node = document.createTextNode(
                    "You don't have any item in cart at the moment!!"
                  );
                  paragraphElement.appendChild(node);
                  paragraphElement?.classList?.add("text-center");
                  sectionContainer.appendChild(paragraphElement);
                }
                const productElement = document.querySelector(
                  `.product-summary[data-slug="${slug}"]`
                );
                productElement.remove();
                updateGrandTotal();
              })
              .catch((error) => {
                console.error("Error removing product to cart:", error);
              });
          }

          function handleQuantityUpdate(slug, quantity) {
            fetch("{% url 'add_to_cart' %}?update=true", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({
                // cart_items: cartItems,
                slug: slug,
                quantity: quantity,
              }),
            }).then((response) => {
              if (!response.ok) {
                throw new Error("Failed to add to cart");
              }
              return response.json();
            });
            // .then((result) => {
            //   if (result.cart_count) {
            //     const cartElement = document.getElementById("cart-count");
            //     cartElement.textContent = result.cart_count;
            //   }
            // })
            // .catch((error) => {
            //   console.error("Error adding product to cart:", error);
            // });
          }

          //@ts-ignore
          if (typeof Toastify === "undefined") {
            const script = document.createElement("script");
            script.onload = initToastLib;
            script.src = "https://cdn.jsdelivr.net/npm/toastify-js";
            document.body.appendChild(script);
          } else {
            initToastLib();
          }

          document.querySelectorAll(".cart-item").forEach((container) => {
            const removeBtnDesktop = container.querySelector(
              ".remove-item"
            ) as HTMLButtonElement;
            const removeBtnMobile = container.querySelector(
              ".remove-item-mobile"
            ) as HTMLButtonElement;
            const quantityInputMobile = container.querySelector(
              ".item-quantity-mobile"
            ) as HTMLInputElement;
            const quantityInputDesktop = container.querySelector(
              ".item-quantity-desktop"
            ) as HTMLInputElement;
            const minusBtnMobile = container.querySelector(
              ".minus-btn"
            ) as HTMLButtonElement;
            const plusBtnMobile = container.querySelector(
              ".plus-btn"
            ) as HTMLButtonElement;
            const minusBtnDesktop = container.querySelector(
              ".minus-btn-desktop"
            ) as HTMLButtonElement;
            const plusBtnDesktop = container.querySelector(
              ".plus-btn-desktop"
            ) as HTMLButtonElement;

            function handleQuantityChange(isIncrease: boolean) {
              let Desktopvalue = parseInt(quantityInputDesktop.value) || 1;
              let Mobilevalue = parseInt(quantityInputMobile.value) || 1;
              const maxValue =
                parseInt(quantityInputDesktop.getAttribute("max"), 10) || 10;
              quantityInputDesktop.value = (
                isIncrease
                  ? Math.min(maxValue, Desktopvalue + 1)
                  : Math.max(1, Desktopvalue - 1)
              ).toString();
              quantityInputMobile.value = (
                isIncrease
                  ? Math.min(maxValue, Mobilevalue + 1)
                  : Math.max(1, Mobilevalue - 1)
              ).toString();
              updateTotalPrice(container as HTMLElement);
            }
            const containerElement = container as HTMLElement;
            if (!containerElement.dataset.listeners) {
              plusBtnMobile?.addEventListener("click", () =>
                handleQuantityChange(true)
              );
              minusBtnMobile?.addEventListener("click", () =>
                handleQuantityChange(false)
              );
              plusBtnDesktop?.addEventListener("click", () =>
                handleQuantityChange(true)
              );
              minusBtnDesktop?.addEventListener("click", () =>
                handleQuantityChange(false)
              );
              removeBtnDesktop?.addEventListener("click", () => {
                handleRemoveItem(removeBtnDesktop);
              });
              removeBtnMobile?.addEventListener("click", () => {
                handleRemoveItem(removeBtnDesktop);
              });

              quantityInputMobile?.addEventListener("input", () =>
                updateTotalPrice(container as HTMLElement)
              );
              quantityInputDesktop?.addEventListener("input", () =>
                updateTotalPrice(container as HTMLElement)
              );

              containerElement.dataset.listeners = "true";
            }

            updateTotalPrice(container as HTMLElement);
          });
        },
      },
    },
  });
};
